import { createContext, Dispatch, SetStateAction } from 'react'

export type DrawerContextValue = {
  open?: boolean
  setOpen?: Dispatch<SetStateAction<boolean>>
}

export const DrawerContext = createContext<DrawerContextValue>({})
